export const create = {
  createSuccessfully: '新しいオペレーターを正常に作成しました！',
}
